import { Injectable } from '@angular/core';
export interface NotificationOptions
{
  type?:string;
  message?:string;
  timer?:number;
  closeable?:boolean;
}
@Injectable()

export class NotificationService
 {
   isNotificationHidden:boolean=true;
   notifications:any[];
   manualDismiss:boolean=false;
   timeToClose:any=3000;
   timerHandle:any;
   message:string;
   bgType:string;
   iconType:string;

  constructor() { }
  showNotification(options?:NotificationOptions)
  {
    //console.log('entered _notificationService');
    if(!this.isNotificationHidden)
    {
    return;
    }
    if(options && (options.timer || options.timer==0))
    {
      this.timeToClose=options.timer;
    }
    else
    {
      this.timeToClose=5000;
    }

    this.message=(options && options.message)|| 'System Notification';
    const type=(options && options.type) || 'deault';
    this.manualDismiss=(options && options.closeable)|| false;


    switch (type) 
    {
      case 'success':
          //console.log("test notification.");
          this.bgType = 'bg-success';
          this.iconType = 'fa-thumbs-o-up';
          //console.log(type);
          break;
      case 'error':
          this.bgType = 'bg-danger';
          this.iconType = 'fa-exclamation-triangle';
          //console.log(type);
          break;
      case 'warning':
          this.bgType = 'bg-warning';
          this.iconType = 'fa-exclamation-triangle';
          break;
      case 'default':
      default:
          this.bgType = 'bg-primary';
          this.iconType = 'fa-exclamation-triangle';
          break;
    }
    this.isNotificationHidden=false;


    if(this.timeToClose >0)
    {
      this.setTimers();
    }
    else
    {
      this.manualDismiss=true;
    }
  }

  setTimers()
  {
    this.timerHandle = setTimeout(() => {
      this.isNotificationHidden = true;
      setTimeout(() => {
          this.message = '';
          this.bgType = '';
          this.iconType = '';
          this.timeToClose = 3000;
      }, 600);
  }, this.timeToClose);
}
}

